module.exports = __webpack_public_path__ + "static/img/lohas-download.37b2d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/lohas-download.png
// module id = gn4K
// module chunks = 2